import React from 'react';
import styled from 'styled-components';
import { ChevronDown } from '@styled-icons/bootstrap/ChevronDown';
import { ChevronUp } from '@styled-icons/bootstrap/ChevronUp';
import { useTranslation } from 'react-i18next';
const Container = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[800]};
  margin: ${({ margin }) => margin || '22px 28px 28px'};
`;
const OpenDetailsText = styled.span `
  font-size: 14px;
  margin-left: 16px;
`;
const IconTextContainer = styled.div `
  display: flex;
  align-items: center;

  svg {
    > path {
      stroke: ${({ theme }) => theme.palette.grey[500]};
      stroke-width: 2;
    }
  }
`;
const OpenDetailsButton = ({ open, toggle, margin, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, { onClick: toggle, margin: margin }, open ? (React.createElement(IconTextContainer, null,
        React.createElement(ChevronUp, { size: 14 }),
        React.createElement(OpenDetailsText, null, t('minimize-content')))) : (React.createElement(IconTextContainer, null,
        React.createElement(ChevronDown, { size: 14 }),
        React.createElement(OpenDetailsText, null, t('expand-content'))))));
};
export default OpenDetailsButton;
